<template>
<div>
    <div v-if="isLoading" class="w-10 h-10 mt-20 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
    <dl v-else class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        <div class="overflow-hidden bg-white sm:rounded-lg sm:shadow sm:col-span-2 lg:shadow lg:rounded-lg">
            <div class="py-3 sm:px-4 sm:py-5 lg:py-3 lg:px-3">
                <dt class="text-sm font-medium text-gray-500">
                    Total {{ sunshineSummary[0].key}}
                </dt>
                <dd v-if="canViewSunshineTotal" class="mt-1 text-xl font-bold text-green-600 sm:text-2xl md:text-3xl lg:text-2xl">
                    {{ moneyToString(sunshineSummary.year_totals[0].year_totals.value) }}
                </dd>
            </div>
        </div>
        <div class="overflow-hidden bg-white sm:rounded-lg sm:shadow sm:col-span-2 lg:shadow lg:rounded-lg">
            <div class="py-3 sm:px-4 sm:py-5 lg:py-3 lg:px-3">
                <dt class="text-sm font-medium text-gray-500">
                    Total Surgeons {{ sunshineSummary[0].key }}
                </dt>
                <dd v-if="canViewSunshineTotalSurgeons" class="mt-1 text-xl font-bold text-blue-800 sm:text-2xl md:text-3xl lg:text-2xl">
                    {{ sunshineSummary[0].total_surgeons.value }}
                </dd>
            </div>
        </div>
        <div class="overflow-hidden bg-white sm:rounded-lg sm:shadow sm:col-span-2 lg:shadow lg:rounded-lg">
            <div class="py-3 sm:px-4 sm:py-5 lg:py-3 lg:px-3">
                <dt class="text-sm font-medium text-gray-500">
                    Active Royalty Agreements
                </dt>
                <dd v-if="canViewActiveRoyalty" class="mt-1 text-xl font-bold text-blue-800 sm:text-2xl md:text-3xl lg:text-2xl">
                    {{ getRoyalties() }}
                </dd>
                <dd v-else>
                    <hidden-attribute-button
                        :model-id=modelId
                        model-type="manufacturer"
                        attribute-name="active_royalty"
                        attribute-title="Active Roalty"
                    >
                    </hidden-attribute-button>
                </dd>
            </div>
        </div>
        <div class="overflow-hidden bg-white sm:rounded-lg sm:shadow sm:col-span-2 lg:shadow lg:rounded-lg">
            <div class="py-3 sm:px-4 sm:py-5 lg:py-3 lg:px-3">
                <dt class="text-sm font-medium text-gray-500">
                    Active Consulting Agreements
                </dt>
                <dd v-if="canViewActiveConsulting" class="mt-1 text-xl font-bold text-blue-800 sm:text-2xl md:text-3xl lg:text-2xl">
                    {{ getConsulting() }}
                </dd>
                <dd v-else>
                    <hidden-attribute-button
                        :model-id=modelId
                        model-type="manufacturer"
                        attribute-name="active_consulting"
                        attribute-title="Active Consulting"
                    >
                    </hidden-attribute-button>
                </dd>
            </div>
        </div>
    </dl>
</div>
</template>
<script>
export default {
    props: {
        sunshineRoute: {
            type: String,
            required: true
        },
        modelId: {
            type: Number,
            required: true,
        },
        canViewSunshineTotal: {
            type: Boolean,
            required: true,
        },
        canViewSunshineTotalSurgeons: {
            type: Boolean,
            required: true,
        },
        canViewActiveRoyalty: {
            type: Boolean,
            required: true,
        },
        canViewActiveConsulting: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            sunshineSummary: {},
            isLoading: true,
        }
    },
    created() {
        this.loadSunshineData();
    },
    methods: {
        async loadSunshineData() {
            try {
                this.isLoading = true;
                const response = await axios.get(this.sunshineRoute);
                this.sunshineSummary = response.data;

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },
        moneyToString( num ) {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            });

            return formatter.format(parseFloat(num));
        },
        getRoyalties()
        {
            let royalties = 0;
            this.sunshineSummary[0].nature_of_payment.buckets.forEach(function (item) {
               if (item.key === 'Royalty or License') {
                royalties = item.nature_cardinality.value;
               }
            });

            return royalties;
        },
        getConsulting()
        {
            let consulting = 0;
            this.sunshineSummary[0].nature_of_payment.buckets.forEach(function (item) {
               if (item.key === 'Consulting Fee') {
                consulting = item.nature_cardinality.value;
               }
            });

            return consulting;
        },
    },
}
</script>
